import {
  ApiGetRequest,
  ApiBlobGetRequest,
  // ApiPostRequest,
  // ApiDeleteRequest,
  // ApiPutRequest,
} from '../../../api';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Report - Cashier',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/report',
      },
      {
        text: 'Report - Cashier',
        href: '/adm/opr/report/cashier',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'created_at',
    sortDesc: true,
    export: 0,
    fields: [
      {
        key: 'trans_principle',
        label: 'Principle',
      },
      {
        key: 'created_at',
        label: 'Time',
      },
      {
        key: 'trans_doc',
        label: 'D/O No',
      },
      {
        key: 'trans_use_by',
        label: 'Use By',
      },
      {
        key: 'trans_code',
        label: 'Document No',
      },
      {
        key: 'trans_party',
        label: 'Party',
      },
      {
        key: 'total_idr',
        label: 'IDR',
      },
      {
        key: 'total_usd',
        label: 'USD',
      },
    ],
    detail: false,
    total_idr: 0,
    total_usd: 0,
    form: {
      id_user: '',
      name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  reportCashier(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getReportCashier({ commit, state }) {
    commit('reportCashier', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      date: '',
      start_date:
        data.form.date && data.form.date.length > 0 && data.form.date[0]
          ? moment(data.form.date[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.form.date && data.form.date.length > 0 && data.form.date[1]
          ? moment(data.form.date[1]).format('YYYY-MM-DD')
          : '',
    };
    let result = await ApiGetRequest(`opr/report/cashier`, params);
    commit('reportCashier', {
      items: result.data.object || [],
      total: result.data.total || 0,
      total_idr: result.data.total_idr ? result.data.total_idr : 0,
      total_usd: result.data.total_usd ? result.data.total_usd : 0,
      loading: false,
    });

    return result.error ? false : true;
  },

  async getExportReportCashier({ commit, state }) {
    commit('reportCashier', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      date: '',
      start_date:
        data.form.date && data.form.date.length > 0 && data.form.date[0]
          ? moment(data.form.date[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.form.date && data.form.date.length > 0 && data.form.date[1]
          ? moment(data.form.date[1]).format('YYYY-MM-DD')
          : '',
      export: 1,
    };

    let result = await ApiBlobGetRequest(`opr/report/cashier`, params);
    commit('reportCashier', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'report_cashier.xlsx';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },
};
